<template>
	<div class="ReSelectCascadeServices">
		<div class="row checkbox-radios" v-if="hide_rb_service === false">
			<div class="col-12">
				<base-radio v-for="(el_opt, el_index) in masRadio" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="value.rb_service" inline>{{el_opt.label}}</base-radio>
			</div>
		</div>
		<div class="row select" v-if="value.rb_service == '1' || hide_rb_service===true">
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать услугу"
					v-model="value.bp_id"
					@change="onService"
					:disabled="value.rb_service != '1'"
					:filterable="true"
					:multiple="multi_service_check"
				>
					<el-option
						v-for="(el_opt, el_index) in selServOpts"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="value.bp_id = ''; value.stage_id = ''; value.task_id = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<div class="row select" v-if="(value.rb_service == '1' || hide_rb_service===true) && (stage_hide === false) && (multi_service === false)">
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать этап"
					v-model="value.stage_id"
					@change="onStage"
					:disabled="value.rb_service != '1'"
				>
					<el-option
						v-for="(stage, el_index) in selStageOpts"
						class="select-primary"
						:value="stage.value"
						:label="stage.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="value.stage_id = ''; value.task_id = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<div class="row select" v-if="(value.rb_service == '1' || hide_rb_service===true) && (stage_hide === false) && (multi_service === false)">
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать задачу"
					v-model="value.task_id"
					:disabled="value.rb_service != '1'"
				>
					<el-option
						v-for="(task, el_index) in masTaskOpts"
						class="select-primary"
						:value="task.value"
						:label="task.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="value.task_id = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	import { BaseRadio } from 'src/components/index';
	export default {
		name: 'ReSelectCascadeServices',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			BaseRadio,
		},
		props: {
			value: Object,
			findId: {
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: false
			},
			hide_rb_service:{
				type: Boolean,
				default: false
			},
			multi_service:{
				type: Boolean,
				default: false
			},
			stage_hide:{
				type: Boolean,
				default: false
			},	
		},
		data () {
			return {
				ver: 1,
				objApiData:{},
				objCurStage:{},
				objCurBp:{},
				selServOpts: [],
				selStageOpts: [],  
				masTaskOpts: [],
				masRadio:[{name: '0', label: 'Всё',}, {name: '1', label: 'С услугой',},{name: '2', label: 'Без услуги',}],
				// masRadio:[{name: '1', label: 'С услугой',},{name: '2', label: 'Без услуги',}],
				objGetParams: {},
			}
		},
		computed: {
			rb_services(){return this.value.rb_service;},
			multi_service_check: function(){
				if(this.multi_service === true) {return true;} else {return false;}
			}
		},
		watch:{
			rb_services(val){
				if(this.value.rb_service == '2' || this.value.rb_service == '0'){
					this.value.bp_id = '';
					this.value.stage_id = '';
					this.value.task_id = '';
				}
			}
		},
		methods: {
			onService(bp_id,bForce=false){
				if(this.multi_service === false){
					for (let i = 0; i < this.objApiData.length; i++) {
						if(this.objApiData[i].id == bp_id){
							this.selStageOpts = [];
							this.masTaskOpts = [];
							this.value.stage_id = '';
							this.value.task_id = '';
							this.objCurBp = this.$GVO.unlinkObject(this.objApiData[i]);
							for (let s = 0; s < this.objApiData[i].stages.length; s++) {
								this.selStageOpts.push({'value':this.objApiData[i].stages[s].id.toString(),'label':this.objApiData[i].stages[s].name});
							}
						}
					}
				} else {

				}
			},
			onStage(stage_id){
				for (let i = 0; i < this.objCurBp.stages.length; i++) {
					if(this.objCurBp.stages[i].id == stage_id){
						this.masTaskOpts = [];
						this.value.task_id = '';
						for (let t = 0; t < this.objCurBp.stages[i].TASKS.length; t++) {
							this.masTaskOpts.push({'value':this.objCurBp.stages[i].TASKS[t].id.toString(),'label':this.objCurBp.stages[i].TASKS[t].name});
						}
					}					
				}
			},
			onRBChange(opt){
				// console.log(opt);
			},
			getBPList(){
				this.objGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('GET',{obj:'BP',flt:{'cascade':true,'only_act':true/*,'archived':true*/}})
				.then((objApi) => {
					if(objApi.success === true){
						this.selServOpts = [];
						//console.log(objApi);
						this.objApiData=objApi.data.BP_DATA;
						for (let i = 0; i < objApi.data.BP_DATA.length; i++) {
							this.selServOpts.push({'value':objApi.data.BP_DATA[i].id.toString(),'label':objApi.data.BP_DATA[i].name});
						}
						if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === false) this.value.bp_id = this.objGetParams['bp_id'];
						if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === true) this.value.bp_id = this.objGetParams['bp_id'].split(',');
						if (this.value.bp_id != '' ) {this.onService(this.value.bp_id,true);} 

						if(typeof this.objGetParams['stage_id'] !='undefined' && this.objGetParams['stage_id'] != '') this.value.stage_id = this.objGetParams['stage_id'];
						if (this.value.stage_id != '') {
							//this.onStage(this.value.stage_id);
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
		},
		mounted() {
			this.getBPList();
		}
	}
</script>
<style scoped>
	.row{margin-bottom: 10px;}
	.row.select{
		flex-wrap: nowrap;
		margin-right: 0;
		margin-left: 0;
	}
	.row.select>*{padding: 0px;}
</style>
